<template>
  <!-- 动画的 -->
  <div
    id="abousUS"
    :class="{
      box: true,
      'landscape-box': isLandscape,
      'portrait-box': !isLandscape,
      en: lang === 'en-US',
    }"
  >
    <div
      id="abousUsAboutCar"
      :style="{ 'background-image': 'url(' + imageUrl + ')' }"
      v-lazy="imageUrl"
    >
      <div
        id="top"
        class="aboutUsTitle wow animate__animated animate__fadeInUp"
      >
        <div id="title">{{ $t("aboutUs").h1 }}</div>
        <p id="p1">{{ $t("aboutUs").h2 }}</p>
        <p id="p2">{{ $t("aboutUs").h3 }}</p>
      </div>
      <div id="aboutbottom" class="aboutUsBottom">
        <div
          id="aboutbottom1"
          class="wow animate__animated animate__backDropFilterBlur"
          style="animation-duration: 2.5s"
        >
          <div id="img"><img src="@/static/img/icon-values.png" alt="" /></div>
          <div id="title">{{ $t("aboutUs").moudle1.h1 }}</div>
          <div id="pargra">{{ $t("aboutUs").moudle1.h2 }}</div>
        </div>
        <div
          id="aboutbottom2"
          class="wow animate__animated animate__backDropFilterBlur"
          style="animation-duration: 2.5s"
        >
          <div id="img"><img src="@/static/img/icon-mission.png" alt="" /></div>
          <div id="title">{{ $t("aboutUs").moudle2.h1 }}</div>
          <div id="pargra">{{ $t("aboutUs").moudle2.h2 }}</div>
        </div>
        <div
          id="aboutbottom3"
          class="wow animate__animated animate__backDropFilterBlur"
          style="animation-duration: 2.5s"
        >
          <div id="img"><img src="@/static/img/icon-vision.png" alt="" /></div>
          <div id="title">{{ $t("aboutUs").moudle3.h1 }}</div>
          <div id="pargra">{{ $t("aboutUs").moudle3.h2 }}</div>
        </div>
      </div>
    </div>
    <div
      id="abousUsProcess"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="content">
        <div id="text">
          <div
            id="title"
            class="aboutUsProgress wow animate__animated animate__fadeInUp"
          >
            {{ $t("aboutUs").development.h1 }}
          </div>
          <div class="timeline">
            <div class="aboutUsEvent">
              <div v-for="(item, index) in $t('aboutUs').development.list" :key="index" class="year-section flex">
                <div class="left wow animate__animated animate__fadeInUp">
                  {{ item.year }}
                </div>
                <div class="splitline flex column items-center wow animate__animated animate__fadeInUp">
                  <div class="dot"></div>
                  <div class="line"></div>
                </div>
                <div class="right flex column wow animate__animated animate__fadeInUp">
                  <div v-for="(event, eIndex) in item.events"
                  :key="eIndex" class="event-item flex">
                    <div class="month">
                      {{ event.date }}
                    </div>
                    <div class="content">
                      {{ event.introduce }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="abousUsFooterss" ref="abousUsFooterss">
      <FooterComponents></FooterComponents>
    </div>
  </div>
</template>
<script>
import FooterComponents from "@/components/FooterComponents.vue";
import WOW from "wowjs";
export default {
  computed: {
    isLandscape() {
      return Math.abs(window.orientation) === 90;
    },
    lang() {
      return this.$i18n.locale;
    },
  },
  components: {
    FooterComponents,
  },
  data() {
    return {
      imageUrl: require("@/static/img/AboutUs.png"),
      imageUrl1: require("@/static/img/progressbg.png"),
      imgSrc: [
        { id: 1, url: "https://img1.imgtp.com/2022/10/02/x2zOdyMi.png" },
        { id: 2, url: "https://img1.imgtp.com/2022/10/02/6OcEDlzP.png" },
        { id: 3, url: "https://img1.imgtp.com/2022/10/02/PCii39ly.png" },
      ],
    };
  },
  created() {
    const reloadOnOrientationChange = () => {
      const isLandscape = Math.abs(window.orientation) === 90;
      if (isLandscape) {
        location.reload();
      } else {
        location.reload();
      }
    };
    window.addEventListener("orientationchange", reloadOnOrientationChange);
  },
  mounted() {
    const wow = new WOW.WOW({
      live: false,
      mobile: true,
    });
    wow.init();
    this.dotLineHeight();
  },
  methods: {
    dotLineHeight() {
      //手机端
      // eslint-disable-next-line no-undef
      if (device.mobile()) {
        this.isMobileOrIpadOrPc = "Mobile";
        //手机端横屏检测
        if (window.orientation === 90 || window.orientation === -90) {
          this.$refs.line1.style.height = "50px";
          this.$refs.line2.style.height = "40px";
          this.$refs.line3.style.height = "35px";
          this.$refs.line4.style.height = "35px";
        }
        //手机端竖屏检测
        else {
          this.$refs.line1.style.height = "40px";
          this.$refs.line2.style.height = "25px";
          this.$refs.line3.style.height = "25px";
          this.$refs.line4.style.height = "25px";
        }
      }
      //Ipad端
      // eslint-disable-next-line no-undef
      else if (device.ipad()) {
        this.isMobileOrIpadOrPc = "Ipad";
        //Ipad端横屏检测
        if (window.orientation === 90 || window.orientation === -90) {
          this.$refs.line1.style.height = "4.5rem";
          this.$refs.line2.style.height = "3.8rem";
          this.$refs.line3.style.height = "3.5rem";
          this.$refs.line4.style.height = "3.1rem";
        }
        //Ipad端竖屏检测
        else {
          this.$refs.line1.style.height = "4rem";
          this.$refs.line2.style.height = "3rem";
          this.$refs.line3.style.height = "3rem";
          this.$refs.line4.style.height = "3rem";
        }
      }
      //电脑端检测
      // eslint-disable-next-line no-undef
      else if (device.desktop()) {
        this.isMobileOrIpadOrPc = "PC";
        this.$refs.line1.style.height = "5rem";
        this.$refs.line2.style.height = "3.5rem";
        this.$refs.line3.style.height = "3.8rem";
        this.$refs.line4.style.height = "3.8rem";
      }
    },
  },
};
</script>

<style scoped lang="scss">
//毛玻璃效果动画
:global(.animate__backDropFilterBlur) {
  animation-name: backDropFilterBlur;
}

@keyframes backDropFilterBlur {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

:global(.animate__backDropFilterBlur) {
  animation-duration: 1s !important;
}

.landscape-box {
  /* 横屏 */
  /* display: flex;
    flex-direction: column; */
}

.portrait-box {
  /* 竖屏 */
  display: flex;
  flex-direction: column;
}

#abousUS {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  /* display: flex;
    flex-direction: column; */

  @mixin whar($width, $height, $atio) {
    width: $width;
    height: $height;
    aspect-ratio: $atio;
    box-sizing: border-box;
  }

  @mixin bgar($atio) {
    text-align: center;
    margin-right: 1.5rem;
    aspect-ratio: $atio;
    background-size: cover;
  }

  @mixin display {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @mixin commitaspct {
    opacity: 1;
    width: 50%;
    aspect-ratio: 720/600;
    background-size: contain;
  }

  @mixin fontStyle(
    $fontweight,
    $height,
    $fontSize,
    $lineHeight,
    $letterSpaceing,
    $color
  ) {
    width: fit-content;
    font-weight: $fontweight;
    height: $height;
    font-size: $fontSize;
    font-style: normal;
    line-height: $lineHeight;
    letter-spacing: $letterSpaceing;
    color: $color;
  }

  @mixin gaiAModule4BottomCenterContain {
    width: 24rem;
    display: flex;
    height: 29rem;
    position: relative;
    border-radius: 0.25rem;
    flex-direction: column;
    backdrop-filter: blur(140px);
    box-shadow: 0px 1.5rem 2.5rem rgba(12, 12, 12, 0.4);
    background: linear-gradient(
      192.98deg,
      rgba(128, 186, 240, 0.1) 22.73%,
      rgba(16, 28, 60, 0.1) 72.38%
    );
  }

  #abousUsAboutCar {
    width: 100%;
    @include whar(100%, auto, 2880/1628);
    /* @include whar(100%, auto, 2880/2700); */
    background-size: cover;
    position: relative;
    padding: 38rem 0rem 11rem 0rem;

    #top {
      left: 16rem;
      top: 13.2rem;
      margin: auto;
      position: absolute;

      #title {
        @include fontStyle(
          600,
          3.875rem,
          2.5rem,
          3.875rem,
          0.25rem,
          rgba(255, 255, 255, 0.85)
        );
      }

      p {
        margin-top: 1.25rem;
        @include fontStyle(
          400,
          2rem,
          1rem,
          2rem,
          0.1rem,
          rgba(255, 255, 255, 0.65)
        );
        width: 70vw;
      }

      #p2 {
        margin-top: -0.2rem;
      }
    }

    #aboutbottom {
      width: 100%;
      height: auto;
      bottom: 0rem;
      display: flex;
      position: absolute;
      justify-content: center;

      #aboutbottom1,
      #aboutbottom3 {
        width: 19.0419rem;
        margin-right: 1.25rem;
        box-sizing: border-box;
        border-radius: 0.25rem;
        aspect-ratio: 304.67/310;
        backdrop-filter: blur(200px);
        box-shadow: 0px 24px 40px rgba(12, 12, 12, 0.4);
        background: linear-gradient(
          192.98deg,
          rgba(128, 186, 240, 0.1) 22.73%,
          rgba(16, 28, 60, 0.1) 72.38%
        );

        #img {
          left: 50%;
          top: -3.3rem;
          width: 8.75rem;
          position: absolute;
          margin-left: -4.375rem;
          aspect-ratio: 140/112;

          img {
            width: 100%;
          }
        }

        #title {
          margin-top: 4.5rem;
          @include fontStyle(
            500,
            2.25rem,
            1.5rem,
            2.25rem,
            0.1rem,
            rgba(255, 255, 255, 0.85)
          );
          padding: 0 2.75rem;
        }

        #pargra {
          margin-top: 0.75rem;
          @include fontStyle(
            5400,
            2rem,
            0.7rem,
            2rem,
            0.1rem,
            rgba(255, 255, 255, 0.65)
          );
          padding: 0 2.75rem;
        }
      }

      #aboutbottom2 {
        width: 19.0419rem;
        aspect-ratio: 304.67/310;
        margin-right: 1.25rem;
        border-radius: 0.25rem;
        backdrop-filter: blur(200px);
        box-shadow: 0px 24px 40px rgba(12, 12, 12, 0.4);
        background: linear-gradient(
          192.98deg,
          rgba(128, 186, 240, 0.1) 22.73%,
          rgba(16, 28, 60, 0.1) 72.38%
        );

        #img {
          width: 8.75rem;
          aspect-ratio: 140/112;
          top: -3.3rem;
          position: absolute;
          left: 50%;
          margin-left: -4.375rem;

          img {
            width: 100%;
          }
        }

        #title {
          font-weight: 500;
          font-size: 1.5rem;
          font-style: normal;
          line-height: 2.25rem;
          box-sizing: border-box;
          padding: 4.5rem 0.5rem 0.5rem 2.6rem;

          color: rgba(255, 255, 255, 0.85);
          letter-spacing: 0.1rem;
        }

        #pargra {
          font-weight: 400;
          font-size: 0.7rem;
          font-style: normal;
          box-sizing: border-box;
          padding: 0.2rem 2.6rem 0.5rem;
          line-height: 2rem;
          color: rgba(255, 255, 255, 0.65);
          height: 10rem;
          overflow: hidden;
          overflow-y: auto;

          /* 设置滚动条的宽度和颜色 */
          &::-webkit-scrollbar {
            width: 0;
            background-color: #f1f1f1;
          }
        }
      }
    }
  }

  #abousUsProcess {
    width: 100%;
    @include display;
    background-size: cover;
    background-position: center center;
    //移动端
    flex: 1;
    //PC端
    @include whar(100%, auto, 2880/1628);

    #content {
      #text {
        height: 50rem !important;
        display: flex;
        padding: 3rem 0 0 0;
        align-items: center;
        flex-direction: column;
        @include whar(60em, 35rem, 0);

        #title {
          align-self: center;
          @include fontStyle(
            600,
            3.125rem,
            2.25rem,
            3.125rem,
            0.25rem,
            rgba(255, 255, 255, 0.85)
          );
        }

        .timeline {
          width: 100%;
          margin-top: 3rem;
          position: relative;

          .aboutUsEvent {
            .year-section {
              min-height: 2rem;
              &:last-child {
                .splitline .line {
                  display: none;
                }
              }
            }
            .left {
              box-sizing: border-box;
              // padding: -0.1rem 0 0 0;
              margin-top: -0.1rem;
              width: 5.155rem;
              min-width: 5.155rem;

              font-style: normal;
              font-weight: 400;
              font-size: 1.5rem;
              color: rgba(255, 255, 255, 0.85);
              text-align: center;
            }
            .splitline {
              margin: 0 1.5rem;
              .dot {
                width: 100px;
                height: 100px;
                border-radius: 50%;
                background-color: red;
                margin-top: 0.3rem;
              }
              .line {
                flex: 1;
                width: 0.1rem;
                margin-top: 0.25rem;
                background-color: rgba(139, 166, 229, 0.5);
              }
            }
            .right {
              color: rgba(255, 255, 255, 0.85);
              display: flex;
              letter-spacing: 0.2rem;
              padding-bottom: 2.5rem;
            }
            .event-item {
              margin-bottom: 0.1rem;
            }
            .month {
              min-width: 6rem;
              text-align: right;
              font-size: 0.875rem;
            }
            .content {
              padding: 0rem 0.078rem 0.1rem 1.5rem;
              font-weight: 400;
              font-style: normal;
              font-size: 0.875rem;
            }
          }
        }
      }
    }
  }

  #abousUsFooterss {
    width: 100%;
    height: 18rem;
  }

  &.en {
    #text {
      width: 50rem !important;
    }
    .month {
      min-width: 10rem;
    }
    .content {
      font-size: 0.675rem !important;
      padding-top: 0.1rem !important;
    }
    #abousUsAboutCar #top p {
      height: auto !important;
    }
    #abousUsAboutCar #top #p1,
    #abousUsAboutCar #top #p2,
    #abousUsAboutCar #pargra,
    #content {
      line-height: 1.5 !important;
    }
    #abousUsAboutCar #top #p2 {
      margin-top: 0 !important;
    }
  }
}
</style>
